// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.CombinedGraph_activ_button__MaRxi {    boxShadow: 'none';
    text-transform: none;
    font-size: 16px;
    padding: 6px 12px;
    border: 1px solid;
    line-height: 1.5;
    background-color: #0063cc;
    border-color: #0063cc;
}

.CombinedGraph_inactiv_button__crkpJ {    boxShadow: 'none';
    text-transform: none;
    font-size: 16px;
    padding: 6px 12px;
    border: 1px solid;
    line-height: 1.5;
    background-color: #03336c;
    border-color: #03336c;
}`, "",{"version":3,"sources":["webpack://./src/css/CombinedGraph.module.css"],"names":[],"mappings":";;AAEA,wCAAmB,iBAAiB;IAChC,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,0CAAqB,iBAAiB;IAClC,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB","sourcesContent":["\n\n.activ_button {    boxShadow: 'none';\n    text-transform: none;\n    font-size: 16px;\n    padding: 6px 12px;\n    border: 1px solid;\n    line-height: 1.5;\n    background-color: #0063cc;\n    border-color: #0063cc;\n}\n\n.inactiv_button {    boxShadow: 'none';\n    text-transform: none;\n    font-size: 16px;\n    padding: 6px 12px;\n    border: 1px solid;\n    line-height: 1.5;\n    background-color: #03336c;\n    border-color: #03336c;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activ_button": `CombinedGraph_activ_button__MaRxi`,
	"inactiv_button": `CombinedGraph_inactiv_button__crkpJ`
};
export default ___CSS_LOADER_EXPORT___;
